import { CallForwardingStatusEnum } from '../../models/call-forwarding-status-enum';
import { CallForwardingDto, CallForwardingSearchDto } from '../../models/call-forwarding-dto';
import {
  FETCH_CALL_FORWARDING,
  FETCH_CALL_FORWARDING_SUCCESS,
  FETCH_CALL_FORWARDING_FAILED,
  SET_SEARCH_CALL_FORWARDING,
  EXPORT_CALL_FORWARDING,
  EXPORT_CALL_FORWARDING_SUCCESS,
  EXPORT_CALL_FORWARDING_FAILED,
  CANCEL_CALL_FORWARDING,
  CANCEL_CALL_FORWARDING_SUCCESS,
  CANCEL_CALL_FORWARDING_FAILED,
} from './actions';

export const CALL_FORWARDING_STATE_KEY = 'CALL_FORWARDING_REDUCER';

export interface ICallForwardingState {
  data: CallForwardingDto[];
  total: number;
  loading: boolean;
  exportLoading: boolean;
  cancelLoading: boolean;
  search: CallForwardingSearchDto;
  error: string | null;
}

const defaultState: ICallForwardingState = {
  data: [],
  total: 0,
  loading: false,
  exportLoading: false,
  cancelLoading: false,
  search: {
    status: [CallForwardingStatusEnum.ACTIVE, CallForwardingStatusEnum.SCHEDULED],
    showHistorical: false,
    page: 1,
    pageSize: 20,
  },
  error: null,
};

export const callForwardingReducer = (state = defaultState, { type, payload }: any) => {
  switch (type) {
    case FETCH_CALL_FORWARDING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CALL_FORWARDING_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload?.data || payload || [],
        total: payload?.total || (Array.isArray(payload) ? payload.length : 0),
      };
    case FETCH_CALL_FORWARDING_FAILED:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case SET_SEARCH_CALL_FORWARDING:
      return {
        ...state,
        search: {
          ...state.search,
          ...payload,
        },
      };
    case EXPORT_CALL_FORWARDING:
      return {
        ...state,
        exportLoading: true,
      };
    case EXPORT_CALL_FORWARDING_SUCCESS:
      return {
        ...state,
        exportLoading: false,
      };
    case EXPORT_CALL_FORWARDING_FAILED:
      return {
        ...state,
        exportLoading: false,
        error: payload,
      };
    case CANCEL_CALL_FORWARDING:
      return {
        ...state,
        cancelLoading: true,
      };
    case CANCEL_CALL_FORWARDING_SUCCESS:
      return {
        ...state,
        cancelLoading: false,
      };
    case CANCEL_CALL_FORWARDING_FAILED:
      return {
        ...state,
        cancelLoading: false,
        error: payload,
      };
    default:
      return state;
  }
};
